import { generateRandomNonce, NONCE_LENGTH } from '../crypto-utils';
import { fromUint8Array, toUint8Array } from 'js-base64';

export const encryptAES = async (message: Uint8Array, aesKey: CryptoKey) => {
  const nonce = generateRandomNonce();
  const encrypted = await window.crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv: nonce,
    },
    aesKey,
    message
  );

  const fullMessage = new Uint8Array(nonce.length + encrypted.byteLength);
  fullMessage.set(nonce);
  fullMessage.set(new Uint8Array(encrypted), nonce.length);

  return fromUint8Array(fullMessage);
};

export const decryptAES = async (
  encryptedMessage: string,
  aesKey: CryptoKey
) => {
  const messageBytes = toUint8Array(encryptedMessage);
  const nonce = messageBytes.slice(0, NONCE_LENGTH);
  const encrypted = messageBytes.slice(NONCE_LENGTH, messageBytes.length);

  const decrypted = await window.crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv: nonce,
    },
    aesKey,
    encrypted
  );

  return new Uint8Array(decrypted);
};

export const toAESKey = async (keyBytes: Uint8Array) =>
  window.crypto.subtle.importKey(
    'raw',
    keyBytes,
    {
      name: 'AES-GCM',
    },
    true,
    ['encrypt', 'decrypt']
  );

export const generateRandomAESKey = async () => {
  const key = await window.crypto.subtle.generateKey(
    {
      name: 'AES-GCM',
      length: 256,
    },
    true,
    ['encrypt', 'decrypt']
  );

  return key;
};

export const exportAESKey = async (key: CryptoKey) => {
  const rawKey = await window.crypto.subtle.exportKey('raw', key);
  return fromUint8Array(new Uint8Array(rawKey));
};
